/**
 * @ims/brand-audi — Entry Point
 *
 * Mounts the Audi brand app into #root.
 * All app logic lives in App.tsx and below.
 *
 * @see docs/ims-brand-frontends/01-architecture.md
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('[brand-audi] #root element not found in DOM');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);